<template>
  <div class="row">
    <div class="col-sm-4">
      <label class="control-label">{{title}}</label>
    </div>
    <div class="col-sm-5">
      <div class="alert alert-bordered alert-warning" v-if="!confirmed && confirmationRequired">
        <p>
          Waiting for confirmation by <span class="text-bold">{{confirmRoleTitle}}</span>
        </p>
      </div>
      <template v-if="confirmed && confirmationRequired">
        <div class="alert alert-bordered alert-success pt-5">
          <span class="mr-10">{{completedTitle}}</span>
        </div>
      </template>
    </div>
    <div class="col-sm-3">
      <template v-if="allowedFor(allowedRoles) && (!confirmed && confirmationRequired)">
        <div class="row">
        <div class="col-sm-8">
          <div class="input-group">
            <date-range-picker :single="true" :period="dateValue" @periodchanged="dateChanged"></date-range-picker>
            <div class="input-group-btn">
              <a @click.prevent="setDate()" class="btn btn-default">{{setTitle}}</a>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <a @click.prevent="confirm()" class="btn btn-success mr-10">{{confirmTitle}}</a>
        </div>
        </div>
      </template>
      <template v-else-if="value && confirmationRequired && confirmed">
        <div class="form-group">
          <label class="control-label">{{dateTitle}}:</label> <span class="form-control">{{dateValue | moment(dateFormat)}}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import DateRangePicker from '@/components/_partial/_atomic/DateRangePicker'

export default {
  name: 'DateStepView',
  components: { DateRangePicker },
  props: {
    'title': {
      type: String,
      required: true
    },
    'allowedRoles': {
      type: Array,
      required: false
    },
    'dateField': {
      type: String,
      required: true
    },
    'confirmField': {
      type: String,
      required: false
    },
    'value': {
      type: String,
      required: false
    },
    'confirmed': {
      type: Boolean,
      required: false,
      default: false
    },
    'confirmationRequired': {
      type: Boolean,
      required: false,
      default: false
    },
    'strictCheck': {
      type: Boolean,
      required: false,
      default: false
    },
    //
    'dateTitle': {
      type: String,
      required: false,
      default: 'Date'
    },
    'setTitle': {
      type: String,
      required: false,
      default: 'Set date'
    },
    'confirmTitle': {
      type: String,
      required: false,
      default: 'Confirm'
    },
    'confirmRoleTitle': {
      type: String,
      required: false,
      default: 'Agency Agent'
    },
    'completedTitle': {
      type: String,
      required: false,
      default: 'Completed'
    },
    //
    'dateFormat': {
      type: String,
      required: false,
      default: 'MM/DD/YYYY'
    },
    //
    'callback': {
      type: Function,
      required: false,
      default: function () {
      }
    }
  },

  data () {
    return {
      dateValue: ''
    }
  },

  beforeMount () {
    this.dateValue = this.$moment(this.value, 'YYYY-MM-DD').format(this.dateFormat)
  },

  methods: {
    allowedFor (roles) {
      let result = false
      if (!Array.isArray(roles) || (Array.isArray(roles) && roles.length === 0)) {
        return true
      }
      for (let i in roles) {
        if (this._is(roles[i])) {
          return true
        }
      }
      return result
    },
    //
    setDate () {
      this.$emit('set', { field: this.dateField, value: this.dateValue })
    },

    confirm () {
      let result = true
      if (this.strictCheck) {
        result = !this.$moment(this.dateValue).isAfter(this.$moment())
      }
      if (result) {
        this.$emit('confirm', { field: this.dateField })
      } else {
        this.$emit('confirmInvalid', { field: this.dateField })
      }
    },
    //
    dateChanged (value) {
      this.dateValue = value
      if (this.callback) {
        this.callback(this.dateValue)
      }
    }
  }
}
</script>

<style scoped>

</style>
